export default __webpack_public_path__ + "static/done-59fc86a1aeca3889c06f8436c4d6324c.png";